export default __webpack_public_path__ + "beta-maps-guides-3d-terrain-960-72cfcab4fd8672eeb2e6b9a62d6fed71.png";